module.exports = __webpack_public_path__ + "static/img/medal-01.7cd9a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medal-01.png
// module id = khGn
// module chunks = 1